<template>
  <div class="block_wrap">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('client.groups.name') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.total') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.config_default') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.ts') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <a
            v-for="(group,key) in groups"
            :key="key"
            :href="pseudo_link(group)"
            @click.prevent='close_modal(group)'
            class="group"
          >
            <tr
              class="pointer"
            >
              <td :data-label="translate('client.groups.name')">
                {{ group.name }}
              </td>
              <td :data-label="translate('client.groups.total')">
                {{ group.total }}
              </td>
              <td :data-label="translate('client.groups.config_default')">
                {{ group.config_default }}
              </td>
              <td :data-label="translate('client.groups.ts')">
                {{ get_date(group.ts_create) }}
              </td>
            </tr>
          </a>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DeviceGroups',
  props: ['groups'],

  data () {
    return {
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    pseudo_link(group){
      return '/device_group/' + group.id
    },
    async close_modal (group) {
      await this.cancel()
      await this.$router.push({path: '/device_group/' + group.id})
    },
  }
}

</script>

<style lang='scss' scoped>
.block_wrap{
  height: 100%;
  .response_table{
    padding: 0;
    table{
      tbody{
        .group{
          color: #333333;
          &:hover{
            tr{
              background-color: #eee;
            }
          }
        }
      }
    }
  }
}

</style>
